import { Outlet, Link } from "react-router-dom";
import { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
function Layout() {
  const [navOpen, setNavOpen] = useState(false);

  const handleMobileToggle = () => {
    debugger
    setNavOpen(prev => !prev);
  };

  const closeMobileMenu = () => {
    setNavOpen(false);
  };

  return (
    <>
      <header id="header" className="header sticky-top">
        <div className="topbar d-flex align-items-center dark-background">
          <div className="container d-flex justify-content-center justify-content-md-between">
            <div className="contact-info d-flex align-items-center">
              <i className="bi bi-envelope d-flex align-items-center">
                <a href="mailto:caspassociates01@gmail.com">
                  caspassociates01@gmail.com
                </a>
              </i>
              <i className="bi bi-phone d-flex align-items-center ms-4">
                <span>+91-9910668717</span>
              </i>
            </div>
            <div className="social-links d-none d-md-flex align-items-center">
              <a href="#" className="twitter">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a href="#" className="facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#" className="instagram">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="#" className="linkedin">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
        <Navbar/>
       </header>
        <main className="main">
        <Outlet />
        </main>
        <Footer/>

      <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center">
        <i className="bi bi-arrow-up-short"></i>
      </a>
    </>
  );
}

export default Layout;
